import muster from '@dbk-legacy/muster';
import { watchValues, ref, getValues } from '@dbk-legacy/muster/utils';
import { redirectOn, variable, sortable} from '@dbk-legacy/muster/helpers';
import map from 'lodash/fp/map';

import addCommonAssets from './assets-common';
import { PAGE } from '../constants';

export default () => {
  const module = muster();

  addCommonAssets(module, {
    positionsSortedRoute: false,
    staticRoute: false,
  });

  module
    .path('positionTypeToUse',
      ({ res }, { get }) =>
        watchValues(get([
          'state.selectedPositionType',
          'positions.deposits.length',
          'positions.funds.length',
        ]))
          .map(([selectedPositionType, depositsLength, fundsLength]) => {
            // By default, can choose the position type to display, but if
            // there are any empty position types, then restrict the choice
            let positionTypeToUse;
            if (depositsLength > 0 && fundsLength === 0) {
              positionTypeToUse = 'deposits';
            } else if (depositsLength === 0 && fundsLength > 0) {
              positionTypeToUse = 'funds';
            } else if (depositsLength > 0 && fundsLength > 0) {
              positionTypeToUse = selectedPositionType;
            } else {
              positionTypeToUse = 'funds';
            }

            // Pass back the re-mapped values
            return res.value(positionTypeToUse);
          })
    )
    .match('positions.deposits[{integers:i}][{keys:k1}][{keys:k2}]', map(({ req, res }) =>
      res.redirect(
        `assetsCommon.data.positions.deposits[${req.params.i}].${req.params.k1}.${req.params.k2}`
      )
    ))
    .match('positions.deposits[{integers:i}][{keys:k}]', map(({ req, res }) =>
      res.redirect(`assetsCommon.data.positions.deposits[${req.params.i}].${req.params.k}`)
    ))
    .path('positions.deposits.length', ({ res }) =>
      res.redirect('assetsCommon.data.positions.deposits.length')
    )
    .path('positions.deposits.pageOffset', variable(0))
    .path('positions.deposits.pageSize', ({ res }, { get }) =>
      getValues(get(['assetsCommon.data.positions.deposits.length', 'positions.deposits.pageOffset']))
        .then(([positionsLength, pageOffset]) => {
          const pageOffsetEnd = pageOffset + PAGE.pageSize;

          if (pageOffset === 0 && positionsLength < pageOffsetEnd) {
            /* records is less than page size */
            return {
              path: 'positions.deposits.pageSize',
              value: positionsLength,
            };
          } else {
            /* records is more than page size */
            return {
              path: 'positions.deposits.pageSize',
              value: pageOffsetEnd < positionsLength ? PAGE.pageSize : positionsLength - pageOffset,
            };
          }
        })
    )
    .match('positions.funds[{integers:i}][{keys:k1}][{keys:k2}]', map(({ req, res }) =>
      res.redirect(
        `assetsCommon.data.positions.funds[${req.params.i}].${req.params.k1}.${req.params.k2}`
      )
    ))
    .match('positions.funds[{integers:i}][{keys:k}]', map(({ req, res }) =>
      res.redirect(`assetsCommon.data.positions.funds[${req.params.i}].${req.params.k}`)
    ))
    .path('positions.funds.length', ({ res }) =>
      res.redirect('assetsCommon.data.positions.funds.length')
    )
    .path('positions.funds.pageOffset', variable(0))
    .path('positions.funds.pageSize', ({ res }, { get }) =>
      getValues(get(['assetsCommon.data.positions.funds.length', 'positions.funds.pageOffset']))
        .then(([positionsLength, pageOffset]) => {
          const pageOffsetEnd = pageOffset + PAGE.pageSize;

          if (pageOffset === 0 && positionsLength < pageOffsetEnd) {
            /* records is less than page size */
            return {
              path: 'positions.funds.pageSize',
              value: positionsLength,
            };
          } else {
            /* records is more than page size */
            return {
              path: 'positions.funds.pageSize',
              value: pageOffsetEnd < positionsLength ? PAGE.pageSize : positionsLength - pageOffset,
            };
          }
        })
    )

    .match('positionsSorted.deposits[{integers:index}].*', sortable({
      fromList: 'positions.deposits',
      toList: 'positionsSorted.deposits',
      listOffset: ref('positions.deposits.pageOffset'),
      listLength: ref('positions.deposits.pageSize'),
      isAscending: ref('assetsCommon.sortIsAscending'),
      sortByKey: ref('assetsCommon.sortByKey'),
    }))
    .match('positionsSorted.funds[{integers:index}].*', sortable({
      fromList: 'positions.funds',
      toList: 'positionsSorted.funds',
      listOffset: ref('positions.funds.pageOffset'),
      listLength: ref('positions.funds.pageSize'),
      isAscending: ref('assetsCommon.sortIsAscending'),
      sortByKey: ref('assetsCommon.sortByKey'),
    }))
    .match('positionsSorted.*',
      redirectOn(ref('positionTypeToUse'), typeToUse => `positionsSorted.${typeToUse}`)
    )
    .match('positionsAlias.*',
      redirectOn(ref('positionTypeToUse'), typeToUse => `positions.${typeToUse}`)
    )
    .match('static.*',
      redirectOn(ref('positionTypeToUse'), typeToUse => `assetsCommon.static.${typeToUse}`)
    );

  return module;
};
